import { resHandler, safeAwait } from '@vzmi/component_ec_nodejs_util/dist/lib/FetchDataUtil'
import { PROPOSAL_TYPE } from '@vzmi/shp_shared_compo/dist/constants/proposal.js'
import { getConvertedListing } from '../../UpdateListingInfo/helper'
import { CATEGORY_LAYER, DEFAULT_MENU_DATA, getCombinedMenuData, getMenuResults, getNonExistAttrMenuParams } from '../../../BatchProposal/UpdateAttribute/helper'
import { PATHS } from '../Preview/UpdateListingPreview'
import _ from 'lodash'
import { Toast } from '@vzmi/shp_shared_compo'

export const getProposalById = async (actions, id, proposalType) => {
  if (!id) {
    throw new Error('proposal id is not provided.')
  }
  let requestAction
  let params = { id }
  switch (proposalType) {
    case PROPOSAL_TYPE.UPDATE_LISTING_MODEL:
      requestAction = actions.fetchListingModelProposals
      params = { ...params, fields: '+products' }
      break
    case PROPOSAL_TYPE.UPDATE_LISTING:
      requestAction = actions.fetchListingInfoProposal
      break
    default:
      requestAction = actions.fetchProposals
      break
  }
  const [proposalError, proposalPayload] = await safeAwait(requestAction(params).then(resHandler))
  if (proposalError) {
    console.error('Error fetching proposal data:', proposalError)
    Toast.error(proposalError.message)
    return
  }

  return proposalPayload
}

export const fetchDefaultAttributes = async ({ listingData, fetchStruDataAttrClusterOptions, fetchCategoryOptions }) => {
  const convertedListings = getConvertedListing(listingData)
  const struDataAttrClusterId = _.get(convertedListings, PATHS.OTHER.STRU_DATA_ATTR_CLUSTER_ID, {})
  const nonExistAttrMenuParams = getNonExistAttrMenuParams([convertedListings], DEFAULT_MENU_DATA)
  const results = await getMenuResults(nonExistAttrMenuParams, {
    fetchStruDataAttrClusterOptions,
    fetchCategoryOptions
  })
  const newMenuData = getCombinedMenuData(DEFAULT_MENU_DATA, results)
  const defaultAttributesNames = _.get(newMenuData, `${CATEGORY_LAYER.FOUR}.${struDataAttrClusterId}${PATHS.OTHER.CONVERTED_ATTRIBUTES}`, []).map(v => v.name)

  return defaultAttributesNames
}
